// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { Profile_abstract } from './../abstract/SagaBase/Profile_abstract';
export class Profile extends Profile_abstract {}
